import React from "react";
import { useTable } from "../../Components/useTable";

const BannedUser = () => {
  const type = "Banned Users";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    // { id: "id", numeric: false, label: "ID" },
    { id: "UserCode", numeric: false, label: "RID" },
    { id: "picture", numeric: false, label: "User Picture" },
    { id: "UserName", numeric: false, label: "User Name" },
    { id: "pictureUrl", numeric: false, label: "Proof" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "banType", numeric: false, label: "Ban Type" },
    { id: "time", numeric: false, label: "Time" },
    { id: "action", numeric: false, label: "Action" },
    // { id: "createdAt", numeric: false, label: "Created at" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default BannedUser;
